// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "qliq_protobuf/auth/session.proto" (package "qliq_protobuf.auth", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { PersonType } from "../person_type";
import { ModuleAccessMode } from "./module_access_mode";
import { AppUpgradePolicy } from "./app_upgrade_policy";
import { User } from "./user";
/**
 * @generated from protobuf message qliq_protobuf.auth.Session
 */
export interface Session {
    /**
     * @generated from protobuf field: string access_token = 1;
     */
    accessToken: string;
    /**
     * @generated from protobuf field: string refresh_token = 2;
     */
    refreshToken: string;
    /**
     * @generated from protobuf field: string ws_token = 3;
     */
    wsToken: string;
    /**
     * @generated from protobuf field: qliq_protobuf.auth.User user = 4;
     */
    user?: User;
    /**
     * @generated from protobuf field: string device_uuid = 5;
     */
    deviceUuid: string;
    /**
     * @generated from protobuf field: qliq_protobuf.auth.User impersonated_as = 6;
     */
    impersonatedAs?: User;
    /**
     * @generated from protobuf field: qliq_protobuf.auth.Session.Group current_group = 7;
     */
    currentGroup?: Session_Group;
    /**
     * @generated from protobuf field: string app_host = 8;
     */
    appHost: string;
    /**
     * @generated from protobuf field: qliq_protobuf.auth.AppUpgradePolicy app_upgrade_policy = 9;
     */
    appUpgradePolicy?: AppUpgradePolicy;
    /**
     * @generated from protobuf field: repeated qliq_protobuf.auth.ModuleAccessMode module_access_modes = 10;
     */
    moduleAccessModes: ModuleAccessMode[];
}
/**
 * @generated from protobuf message qliq_protobuf.auth.Session.Group
 */
export interface Session_Group {
    /**
     * @generated from protobuf field: uint32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: bool is_quick_forms_subscribed = 3;
     */
    isQuickFormsSubscribed: boolean;
    /**
     * @generated from protobuf field: bool is_scheduler_integration_enabled = 4;
     */
    isSchedulerIntegrationEnabled: boolean;
    /**
     * @generated from protobuf field: qliq_protobuf.auth.Session.Group parent_group = 5;
     */
    parentGroup?: Session_Group;
    /**
     * @generated from protobuf field: string address = 6;
     */
    address: string;
    /**
     * @generated from protobuf field: string phone = 7;
     */
    phone: string;
    /**
     * @generated from protobuf field: uint32 qliq_id = 8;
     */
    qliqId: number;
    /**
     * @generated from protobuf field: bool is_emr_integration_subscribed = 9;
     */
    isEmrIntegrationSubscribed: boolean;
    /**
     * @generated from protobuf field: repeated string group_setting_emr_connections_enabled = 10;
     */
    groupSettingEmrConnectionsEnabled: string[];
    /**
     * @generated from protobuf field: bool is_saml_sso_auth_enabled = 11;
     */
    isSamlSsoAuthEnabled: boolean;
    /**
     * @generated from protobuf field: bool is_care_campaigns_subscribed = 12;
     */
    isCareCampaignsSubscribed: boolean; // Deprecated -> MODULE_CARE_CAMPAIGNS_ADMIN
    /**
     * @generated from protobuf field: bool is_auto_campaigns_subscribed = 13;
     */
    isAutoCampaignsSubscribed: boolean; // Deprecated -> MODULE_AUTO_CAMPAIGNS_ADMIN
    /**
     * @generated from protobuf field: bool is_sms_logo_subscribed = 14;
     */
    isSmsLogoSubscribed: boolean;
    /**
     * @generated from protobuf field: qliq_protobuf.PersonType person_type = 15;
     */
    personType: PersonType;
    /**
     * @generated from protobuf field: bool is_owned_by_current_user = 16;
     */
    isOwnedByCurrentUser: boolean;
    /**
     * @generated from protobuf field: bool is_usage_limits_enabled = 17;
     */
    isUsageLimitsEnabled: boolean;
    /**
     * @generated from protobuf field: bool is_care_campaign_appointments_subscribed = 18;
     */
    isCareCampaignAppointmentsSubscribed: boolean;
}
// @generated message type with reflection information, may provide speed optimized methods
class Session$Type extends MessageType<Session> {
    constructor() {
        super("qliq_protobuf.auth.Session", [
            { no: 1, name: "access_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "refresh_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "ws_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "user", kind: "message", T: () => User },
            { no: 5, name: "device_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "impersonated_as", kind: "message", T: () => User },
            { no: 7, name: "current_group", kind: "message", T: () => Session_Group },
            { no: 8, name: "app_host", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "app_upgrade_policy", kind: "message", T: () => AppUpgradePolicy },
            { no: 10, name: "module_access_modes", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["qliq_protobuf.auth.ModuleAccessMode", ModuleAccessMode] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message qliq_protobuf.auth.Session
 */
export const Session = new Session$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Session_Group$Type extends MessageType<Session_Group> {
    constructor() {
        super("qliq_protobuf.auth.Session.Group", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "is_quick_forms_subscribed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "is_scheduler_integration_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "parent_group", kind: "message", T: () => Session_Group },
            { no: 6, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "qliq_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 9, name: "is_emr_integration_subscribed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "group_setting_emr_connections_enabled", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "is_saml_sso_auth_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "is_care_campaigns_subscribed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "is_auto_campaigns_subscribed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "is_sms_logo_subscribed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "person_type", kind: "enum", T: () => ["qliq_protobuf.PersonType", PersonType] },
            { no: 16, name: "is_owned_by_current_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "is_usage_limits_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "is_care_campaign_appointments_subscribed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message qliq_protobuf.auth.Session.Group
 */
export const Session_Group = new Session_Group$Type();
